<template>
    <div id="app">
        <Chat v-if="couner === 0" @next="next" @sendZodiak="getZodiak" :person="person" />

    </div>
</template>

<script>
    import "normalize.css";
    import Chat from "./screens/Chat";

    export default {
        name: "app",
        data: function () {
            return {
                person: "Personal Horoscope",
                zodiak: null,
                couner: 0
            }
        },
        components: {
            Chat
        },
        methods: {
            getZodiak(zodiak) {
                this.zodiak = zodiak;
            },
            next(data) {
                this.couner += data;
            }            
        }
    };
</script>

<style lang="scss">
    * {
        box-sizing: border-box;
    }
    
    html,
    body {
        font-family: "Roboto", sans-serif;
        min-width: 320px;
        height: 100%;
        scrollbar-width: none;
        -ms-overflow-style: none;
    }

    #app {
        background: #ede6dd;
        height: 100%;
    }
</style>
